import Vue from 'vue';
import moment from 'moment';

Vue.filter('capitalize', (val) => {
  if (!val) return '';
  val = val.toString();
  const words = val.split(/_/);
  return _.map(words, (w) => {
    let str;
    switch (w.toLowerCase()) {
      case 'api':
        str = w.toUpperCase();
        break;
      default:
        str = w.charAt(0).toUpperCase() + w.slice(1);
    }
    return str;
  }).join(' ');
});

Vue.filter('cents', (val) => {
  if (!val) return '$0.00';
  const float = Number(`${Math.round(`${val / 100}e2`)}e-2`);
  const str = float.toFixed(2);
  const parts = str.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `$${parts.join('.')}`;
});

Vue.filter('date', (val, format = 'MM/DD/YYYY') => {
  if (!val) return '';
  val = val.toString();
  return moment(val).format(format);
});

Vue.filter('time', (val) => {
  if (!val) return '';
  const f = parseFloat(val);
  const hours = Math.floor(f).toString();
  const minutes = f % 1 === 0 ? '00' : '30';
  return `${hours}:${minutes}`;
});

const padLeft = (string) => {
  const length = 2;
  return (new Array(length + 1).join('0') + string).slice(-length);
};

Vue.filter('timecode', (val) => {
  if (!val) return '00:00:00';
  const time = Math.round(val);
  const hours = Math.floor(time / 3600) || 0;
  const minutes = (Math.floor(time / 60) - (hours * 60)) || 0;
  const seconds = (time % 60) || 0;
  return `${padLeft(hours)}:${padLeft(minutes)}:${padLeft(seconds)}`;
});

Vue.filter('fromNow', (val, msg) => {
  if (!val) return msg;
  val = val.toString();
  return moment(val).fromNow();
});

Vue.filter('truncate', (val, stop, clamp) => {
  if (!val) return '';
  return val.slice(0, stop) + (stop < val.length ? clamp || '...' : '');
});

Vue.filter('serviceFrequency', (val) => {
  if (!val || val === 'every') return null;
  const words = val.split(/_/);
  const capitalized = _.map(words, word => word.charAt(0).toUpperCase() + word.slice(1));
  return capitalized.join(' & ');
});

Vue.filter('phoneNumber', (val) => {
  if (!val) return '';
  const stripped = val.replace(/\+1/, '');
  const formatted = `(${stripped.slice(0, 3)}) ${stripped.slice(3, 6)}-${stripped.slice(6, 10)}`;
  return formatted;
});



// WEBPACK FOOTER //
// ./src/utils/filters.js